import { useEffect, useState } from "react";
import "./ExcluirFabricanteEstaleiroModal.css";

export default function ExcluirFabricanteEstaleiroModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao excluir.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbeex-bg" onClick={onClose}>
      <div className="fbeex-box" role="dialog" aria-modal="true" aria-label="Excluir fabricante" onClick={(e) => e.stopPropagation()}>
        <header className="fbeex-head">
          <h3 className="fbeex-title">Excluir</h3>
          <button className="fbeex-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="fbeex-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "este registro"}"?
          <div className="fbeex-warn">Esta acao nao pode ser desfeita.</div>
          {err ? <div className="fbeex-err">{err}</div> : null}
        </div>
        <footer className="fbeex-foot">
          <button className="fbeex-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="fbeex-btn fbeex-btn-danger" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Excluindo..." : "Excluir"}
          </button>
        </footer>
      </div>
    </div>
  );
}

